<template>  
  <div class="pmd container" v-if="isEnabled">
    <h6 class="pmd__title">{{ staticTitle }}</h6>
    <p class="pmd__description body-lg">{{ staticDescription }}</p>
    <img v-if="customFields.pmd_image" class="pmd__image" :src="customFields.pmd_image" alt="">
    <div v-if="!customFields.pmd_image && customFields.product_video" class="pmd__video">
      <iframe :src="`https://www.youtube.com/embed/${videoId}`" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductMoreDetails',
  props: {
    customFields: Object
  },
  computed: {
    isEnabled () {
      return this.customFields.pmd_title || this.customFields.pmd_description || this.customFields.pmd_image || this.customFields.product_video ? true : false
    },
    staticTitle () {
      return this.customFields.pmd_title;
    },
    staticDescription () {
      return this.customFields.pmd_description;
    },
    videoId () {
      const url = this.customFields.product_video;
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return (match && match[2].length === 11) ? match[2] : null;
    }
  }
}
</script>

<style lang="scss" scoped>
.pmd {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: $container-max-width-slim;
  padding: 60px 15px;
  @include mobile-only {
    padding: 30px 15px 50px 15px;
  }
  &__title {
    margin-bottom: 10px;
  }
  &__description {
    margin-bottom: 30px;
    text-align: center;
    @include mobile-only {
      margin-bottom: 20px;
    }
  }
  &__video {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    width: 100%;
    iframe,
    embed,
    object
    {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
